module.exports = __webpack_public_path__ + "media/images/brand/new_stuff_letter/lab_door_x2-95ad6bd3b415f454b02679213bb6846d.jpg";